import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Segment, Icon, Button } from 'semantic-ui-react';

import clsx from 'clsx';
import _isEmpty from 'lodash/isEmpty';

import ConfirmModal from 'components/common/ConfirmModal';
import {
  BULK_OPERATION_ASSIGN_GROUPS,
  BULK_OPERATION_DELETE,
} from 'components/modules/questions/constants';
import { QuestionGroupType } from 'components/modules/questions/types';

import BulkActions from './components/BulkActions';
import GroupSelector from './components/GroupSelector';

import './BulkOperationsBar.scss';

const propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onBulkOperation: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(QuestionGroupType).isRequired,
};

const defaultProps = {};

export default function BulkOperationsBar({
  selectedCount,
  onBulkOperation: onBulkOperationProp,
  groups,
}) {
  const [showGroupSelector, setShowGroupSelector] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  function onBulkActionSelect(operation, value) {
    if (operation === BULK_OPERATION_ASSIGN_GROUPS) {
      setShowGroupSelector(true);
    } else if (operation === BULK_OPERATION_DELETE) {
      setShowDeleteConfirm(true);
    } else {
      onBulkOperationProp(operation, value);
    }
  }

  function onConfirmBulkDelete() {
    onBulkOperationProp(BULK_OPERATION_DELETE);
    setShowDeleteConfirm(false);
  }

  function onGroupAssignment() {
    if (!_isEmpty(selectedGroups)) {
      const groupsToAssign = groups.filter((group) => selectedGroups.includes(group.id));
      onBulkOperationProp(BULK_OPERATION_ASSIGN_GROUPS, groupsToAssign);
      setSelectedGroups([]);
      setShowGroupSelector(false);
    }
  }

  function onGroupSelectionChange(e, { value }) {
    setSelectedGroups(value);
  }

  function cancelGroupAssignment() {
    setSelectedGroups([]);
    setShowGroupSelector(false);
  }

  const isHidden = selectedCount === 0;

  return (
    <Segment
      className={clsx({
        'bulk-operations-bar': true,
        hidden: isHidden,
      })}
      color="blue"
    >
      <div className="bulk-operations-content">
        <div className="selection-info">
          <Icon name="check circle" color="blue" />
          <span className="selected-count">
            {selectedCount} question{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>

        {showGroupSelector && (
          <GroupSelector
            disabled={isHidden}
            groups={groups}
            selectedGroups={selectedGroups}
            onChange={onGroupSelectionChange}
            onConfirm={onGroupAssignment}
            onCancel={cancelGroupAssignment}
          />
        )}
        {!showGroupSelector && <BulkActions onAction={onBulkActionSelect} disabled={isHidden} />}
        <ConfirmModal
          open={showDeleteConfirm}
          header="Delete Questions"
          content={`Are you sure you want to delete ${selectedCount} question${
            selectedCount !== 1 ? 's' : ''
          }? This action cannot be undone.`}
          confirmButton={<Button className="delete-red" content="Delete" />}
          cancelButton={<Button className="action-button-gray" content="Cancel" />}
          onCancel={() => setShowDeleteConfirm(false)}
          onConfirm={onConfirmBulkDelete}
        />
      </div>
    </Segment>
  );
}

BulkOperationsBar.propTypes = propTypes;
BulkOperationsBar.defaultProps = defaultProps;
